import { useMemo } from 'react';
import { Link } from 'react-router-dom';

import { Button, Col } from 'antd';

import { StyledBox } from '@pages/objects/common/components';
import { pathBuilder } from '@utils/pathBuilder';

import { MODE_CREATE, MODE_UPDATE, MODE_VIEW } from '../../constants';

// Создаем словарь для маппинга полей на понятные заголовки
const fieldLabelMap: Record<string, string> = {
    products: 'Товары',
    services: 'Услуги',
    tasks: 'Задачи',
};

const getRundomInt = (min: number, max: number) => {
    const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
    const formatter = new Intl.NumberFormat('ru-RU', { useGrouping: true });

    return formatter.format(randomNumber);
};

export const Footer = ({ objectName }) => {
    // Определение режима работы компонента по URI
    const mode = useMemo(() => {
        const pathname = location.pathname;
        const lastSegment = pathname.split('/').pop()?.toLowerCase();

        if (lastSegment === 'create') {
            return MODE_CREATE;
        } else if (lastSegment === 'edit') {
            return MODE_UPDATE;
        } else {
            return MODE_VIEW;
        }
    }, [location.pathname]);

    if (mode !== MODE_VIEW) {
        // Если режим создания или редактирования, не отображаем футер
        return null;
    }

    return (
        <>
            {['products', 'services', 'tasks'].map((name, idx) => (
                <Col span={8} key={idx}>
                    <StyledBox style={{ fontSize: '13px', textAlign: 'center' }}>
                        <span>Примененные {fieldLabelMap[name]}</span>
                        {/* <Button onClick={() => navigate(`${objectName}/${name}`)}>{getRundomInt(1100000, 1900000)}</Button> */}
                        <Link
                            to={pathBuilder({
                                from: 'objects',
                                path: `statistics/${name}/${encodeURIComponent(objectName)}`,
                            })}
                        >
                            <Button>{getRundomInt(1100000, 1900000)}</Button>
                            {/* <Button onClick={() => navigate(`/lk/worker/crm/1/objects/${objectName}/${name}`)}>{getRundomInt(1100000, 1900000)}</Button> */}
                        </Link>
                    </StyledBox>
                </Col>
            ))}
        </>
    );
};
